<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="广告位设置名称">
          <el-input placeholder="请输入广告位设置名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加广告位设置</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" width="300" label="广告位设置名称"></el-table-column>
            <!-- 修改状态显示 -->
            <el-table-column prop="is_open" label="是否开启" width="300">
              <template slot-scope="scope">
                <el-tag :type="scope.row.is_open === 1 ? 'success' : 'danger'">
                  {{ scope.row.is_open === 1 ? '已开启' : '未开启' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="300"></el-table-column>
            <el-table-column fixed="right" label="操作" width="300">
              <template slot-scope="scope">
                <!-- 根据状态显示不同的按钮 -->
                <el-button 
                  @click="toggleStatus(scope.row)" 
                  :type="scope.row.is_open === 1 ? 'warning' : 'success'" 
                  size="small">
                  {{ scope.row.is_open === 1 ? '关闭' : '开启' }}
                </el-button>
                <el-button 
                  @click="deleteClick(scope.row)" 
                  type="danger" 
                  size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :advertising_space_id="advertising_space_id" v-if="open_edit" @close="closeEdit"></Edit>

    <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" 
      :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
  import Advertising_spaceApi from '@/api/advertising_space.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search: ""
        },
        open_add: false,
        open_edit: false,
        advertising_space_id: "",
        dialogVisible: false,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible() {
        this.dialogVisible = false;
      },
      setting(e) {
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e) {
        this.open_add = false;
        this.getTableList();
      },
      closeEdit(e) {
        this.open_edit = false;
        this.getTableList();
      },
      getData() {
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Advertising_spaceApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
      /*添加任务*/
      addClick() {
        this.open_add = true;
      },
      /*切换开启/关闭状态*/
      toggleStatus(row) {
        let self = this;
        const newStatus = row.is_open === 1 ? 0 : 1;
        const statusText = newStatus === 1 ? '开启' : '关闭';
        
        self.$confirm(`确定要${statusText}这个广告位吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Advertising_spaceApi.edit({
            advertising_space_id: row.advertising_space_id,
            is_open: newStatus
          }, true)
          .then(data => {
            self.$message({
              message: `${statusText}成功`,
              type: 'success'
            });
            // 更新本地数据，避免重新请求
            row.is_open = newStatus;
          })
          .catch(error => {
            self.$message.error('操作失败');
          });
        }).catch(() => {
          // 用户取消操作
        });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Advertising_spaceApi.del({
            advertising_space_id: row.advertising_space_id
          }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error('删除失败');
            }
          })
          .catch(error => {
            self.$message.error('删除失败');
          });
        }).catch(() => {
          // 用户取消操作
        });
      }
    }
  };
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/plus/advertising_space/index/index.vue